var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirm-dialog-template',{attrs:{"title":"unsafe.deal.info.title"},on:{"submit":_vm.handleSubmit,"cancel":_vm.handleCancel},model:{value:(_vm.isShownContent),callback:function ($$v) {_vm.isShownContent=$$v},expression:"isShownContent"}},[_c('p',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.$t('unsafe.deal.info.message')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }